import React from 'react'
import { Text, ActivityIndicator, View } from 'react-native'
import BlurView from '../BlurView'
import { useAppTheme } from '#app/theme'

interface Props {
  label: string
  value: string
}

export default function Potency (props: Props) {
  const theme = useAppTheme()

  return (
    <BlurView
      tint={theme.blurView.tint}
      intensity={theme.blurView.intensity}
      style={[{
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 0,
        margin: 5,
        borderRadius: 12,
        overflow: 'hidden'
      }, { ...theme.border }]}
    >
      <View style={{ padding: 16, flex: 1, justifyContent: 'space-between' }}>
        <Text
          numberOfLines={1}
          adjustsFontSizeToFit
          minimumFontScale={0.5}
          style={{
            fontSize: 11,
            fontWeight: '600',
            letterSpacing: 0.8,
            textTransform: 'uppercase',
            color: theme.colors.grey,
            marginBottom: 8
          }}
        >
          {props.label}
        </Text>

        {/* eslint-disable-next-line @typescript-eslint/strict-boolean-expressions */}
        {(props as any).loading
          ? <ActivityIndicator color={theme.titleLoading.indicatorColor} size="small" style={{ alignSelf: 'flex-start', marginTop: 4 }} />
          : <Text
              style={{
                fontSize: 26,
                fontWeight: '300',
                letterSpacing: -0.5,
                color: theme.home.topConsumption.textColor
              }}
            >
              {props.value}
            </Text>
        }
      </View>
    </BlurView>
  )
}
